/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import { GlobalState } from '../../actions';

export const songEditSelector = (state: GlobalState) => state.playlistAdmin.songEdit;

export const songEditSongSelector = (state: GlobalState) => songEditSelector(state).song;

export const songFullNameSelector = (state: GlobalState) => {
    const s = songEditSongSelector(state);
    if (s) {
        return `${s.name} (${s.artist})`;
    } else {
        return undefined;
    }
}

export const songEditAlbumsSelector = (state: GlobalState) => songEditSelector(state).albums;
